import React, { useEffect, useState } from "react";
import "./NoDeliveryFeeCarousel.css";

import slideImage from "../assets/no_delivery_a.png"; 
import slideImageb from "../assets/offer_b_2.png"; 
import slideImagec from "../assets/offer_c_2.png"; 
import slideImaged from "../assets/offer_d_2.png"; 


// All slides reuse the same image
const SLIDES = [
  { id: 1, image: slideImage },
  { id: 2, image: slideImageb },
  { id: 3, image: slideImagec },
  { id: 4, image: slideImaged },
];

const AUTO_PLAY_MS = 6000;

const NoDeliveryFeeCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % SLIDES.length);
    }, AUTO_PLAY_MS);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="ndf-carousel">
      <div className="ndf-carousel-inner">
        {SLIDES.map((slide, index) => (
          <div
            key={slide.id}
            className={`ndf-slide ${index === activeIndex ? "active" : ""}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          />
        ))}
      </div>

      <div className="ndf-dots">
        {SLIDES.map((_, index) => (
          <button
            key={index}
            type="button"
            className={`ndf-dot ${index === activeIndex ? "active" : ""}`}
            onClick={() => setActiveIndex(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default NoDeliveryFeeCarousel;
